import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Form, { IFormProps } from '../../Form';

export interface IDonorToolGravityFormContainerProps extends IBaseElementProps {
	children?: any;
	sidebarHeading?: string;
	sidebarImage?: IImage;
	/**
	 * Alternating Item Text
	 * @control richtext
	 */
	sidebarText?: string;
	sidebarCalloutText?: string;
	sidebarPhoneNumber?: string;
	formHeading?: string;
	/**
	 * Alternating Item Text
	 * @control richtext
	 */
	formIntroText?: string;
}

/**
 * DonorToolGravityFormContainer
 * @block
 * @requiresHooks
 * @icon editor-insertmore
 */
const DonorToolGravityFormContainer: React.FC<IDonorToolGravityFormContainerProps> =
	({
		children,
		className,
		classNames = [],
		sidebarHeading,
		sidebarText,
		sidebarImage,
		sidebarCalloutText,
		sidebarPhoneNumber,
		formHeading,
		formIntroText,
	}) => (
		<div
			className={
				className ||
				cn(
					'donor-tool-gravity-form-container container-fluid',
					...classNames,
				)
			}
		>
			<div className="donor-tool-gravity-form-container__inner-container">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg col-left">
							<div className="donor-tool-gravity-form-container__sidebar-content">
								{sidebarHeading && (
									<h2 className="donor-tool-gravity-form-container__sidebar-heading">
										{sidebarHeading}
									</h2>
								)}
								{sidebarImage && (
									<Image
										{...sidebarImage}
										className="donor-tool-gravity-form-container__sidebar-image img-fluid"
									/>
								)}
								{sidebarText && (
									<div
										className="donor-tool-gravity-form-container__sidebar-text"
										dangerouslySetInnerHTML={{
											__html: sidebarText,
										}}
									/>
								)}
								{sidebarCalloutText && (
									<p className="donor-tool-gravity-form-container__sidebar-callout-text">
										{sidebarCalloutText}
									</p>
								)}
								{sidebarPhoneNumber && (
									<a
										className="donor-tool-gravity-form-container__sidebar-callout-phone"
										href={`tel:${sidebarPhoneNumber}`}
									>
										{sidebarPhoneNumber}
									</a>
								)}
							</div>
						</div>
						<div className="col-12 col-lg col-right">
							<div className="donor-tool-gravity-form-container__form-content">
								{formHeading && (
									<h2 className="donor-tool-gravity-form-container__form-heading">
										{formHeading}
									</h2>
								)}
								{formIntroText && (
									<div
										className="donor-tool-gravity-form-container__form-intro-text"
										dangerouslySetInnerHTML={{
											__html: formIntroText,
										}}
									/>
								)}
								<div className="donor-tool-gravity-form-container__form-container">
									<Form>{children}</Form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);

export default DonorToolGravityFormContainer;
